<ng-container *ngIf="(displayTrackingLink$ | async); else locationMap">
  <app-external-tracker [url]="(externalServiceUrl$ | async)"></app-external-tracker>
</ng-container>
<ng-template #locationMap>
  <app-map-service-tracking></app-map-service-tracking>
</ng-template>
